import type { sendSyllabusEmail } from '@/actions/email/send-syllabus-email-action'

const DEFAULT_SYLLABUS_EMAIL_ERROR =
  'Não foi possível enviar o programa completo por e-mail. Tente novamente.'

type SendSyllabusEmailResult = Awaited<ReturnType<typeof sendSyllabusEmail>>

export function getSyllabusEmailErrorMessage(
  result: SendSyllabusEmailResult
): string | null {
  if (result?.serverError || result?.validationErrors) {
    return DEFAULT_SYLLABUS_EMAIL_ERROR
  }

  if (result?.data?.status !== 'success') {
    return result?.data?.message ?? DEFAULT_SYLLABUS_EMAIL_ERROR
  }

  return null
}
